export const defaultCheckListMessages = {
  incluir_tac: {
    message: 'Incluir TAC na proposta.',
  },

  reduzir_carencia: {
    message: 'Reduzir carência.',
  },

  incluir_tab: {
    message: 'Incluir TAB na simulação.',
  },

  incluir_avalista: {
    message: 'Incluir avalista.',
  },

  aumentar_taxa: {
    message: 'Aumentar taxa.',
  },

  solicitar_renda: {
    message: 'Comprovação de renda obrigatória.',
  },

  incluir_prestamista: {
    message: 'Incluir seguro prestamista.',
  },

  reduzir_prazo: {
    message: 'Reduzir prazo.',
  },
};
